import cx from 'classnames';
import {EditButton} from '~/common/components/EditButton/EditButton';

export const RemoveAdsButton = ({sidePanel, removeOnClick, useFakeAds}) => (
  <div
    className={cx('google-free-banner__wrapper', {
      'google-free-banner__wrapper--side-panel': sidePanel,
      'google-free-banner__wrapper--real-ad': !useFakeAds,
    })}
  >
    <EditButton
      showPremiumIcon
      onClick={removeOnClick}
      text="Remove Ads"
      data-qa-id="remove-banners"
      isStatic
    />
  </div>
);
